// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--3496V","loader":"styles-module--loader--1PnWs"};